import { defineMessages } from 'react-intl';

import type { SearchIssueStatusCategory } from '@atlassian/search-client/query-generator';

export const i18n: Record<SearchIssueStatusCategory, import('react-intl').MessageDescriptor> =
	defineMessages<SearchIssueStatusCategory>({
		OPEN: {
			id: 'search-page.filter.status.open',
			defaultMessage: 'Open',
			description:
				'Drop-down item label for the Open status category in the Jira issue status filter on the search page.',
		},
		DONE: {
			id: 'search-page.filter.status.done',
			defaultMessage: 'Done',
			description:
				'Drop-down item label for the Done status category in the Jira issue status filter on the search page.',
		},
		INDETERMINATE: {
			id: 'search-page.filter.status.indeterminate',
			defaultMessage: 'In Progress (Open)',
			description:
				'Drop-down item label for the In Progress (Open) status category in the Jira issue status filter on the search page.',
		},
		UNDEFINED: {
			id: 'search-page.filter.status.undefined',
			defaultMessage: 'Other',
			description:
				'Drop-down item label for the Other (uncategorized) status category in the Jira issue status filter on the search page.',
		},
		NEW: {
			id: 'search-page.filter.status.new',
			defaultMessage: 'To Do (Open)',
			description:
				'Drop-down item label for the To Do (Open) status category in the Jira issue status filter on the search page.',
		},
	});
